import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface MarketingIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const MarketingIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick
}: MarketingIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M20.0163 3.43087C19.6509 3.16908 19.1822 3.09798 18.7558 3.23978L12.7023 5.25694H7.20077C6.19353 5.25827 5.22781 5.65893 4.51558 6.37116C3.80349 7.08339 3.40269 8.04911 3.40149 9.05635V10.6561V10.656C3.4043 11.5778 3.74295 12.467 4.35381 13.1573C4.96481 13.8476 5.80627 14.2916 6.72085 14.4065L7.85181 18.9304C8.07878 19.8038 8.75206 20.4913 9.62057 20.7364C10.4891 20.9814 11.4224 20.7474 12.0725 20.1215C12.7225 19.4956 12.9917 18.5718 12.7798 17.6947L11.9687 14.4553H12.7022L18.7557 16.4726V16.4724C18.8982 16.5205 19.0476 16.5448 19.198 16.5445C19.5693 16.5449 19.9255 16.3977 20.1882 16.1353C20.4509 15.8729 20.5985 15.5169 20.5985 15.1456V4.56654C20.5982 4.11634 20.3816 3.69374 20.0163 3.43075L20.0163 3.43087ZM4.60145 10.656V9.05636C4.60225 8.36717 4.87635 7.70646 5.36376 7.21904C5.85104 6.73176 6.51171 6.45765 7.20094 6.45673H12.1999V13.2554L7.20094 13.2555C6.51175 13.2546 5.85104 12.9805 5.36376 12.4932C4.87634 12.0058 4.60224 11.3451 4.60145 10.6559V10.656ZM11.6161 17.9891C11.7199 18.449 11.5744 18.9299 11.233 19.2552C10.8914 19.5803 10.4041 19.7021 9.94962 19.576C9.49528 19.4499 9.14055 19.0941 9.01564 18.6393L7.96942 14.4555H10.7313L11.6161 17.9891ZM19.3989 15.1456H19.3988C19.3999 15.2088 19.37 15.2684 19.3189 15.3055C19.2666 15.3429 19.2 15.3533 19.1389 15.3335L13.3998 13.4227V6.28943L19.1355 4.377C19.1964 4.35598 19.2638 4.36642 19.3154 4.40499C19.3666 4.44208 19.3964 4.5018 19.3954 4.56487L19.3989 15.1456Z"
                fill={color}
            />
        </svg>
    )
}

export default MarketingIcon
